import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Lottie from "lottie-react";
import vissionImg from "./vision.json";
import AOS from "aos";
import "aos/dist/aos.css";
import { useMediaQuery } from "@mui/material";

const PRTPVision = () => {
  const [secondary, setSecondary] = React.useState(false);

  React.useEffect(() => {
    AOS.init();
  }, []);

  const matches = useMediaQuery("(max-width:768px)");

  return (
    <Container>
      <Row
        className="justify-content-center align-items-center flex-wrap-reverse"
        id="vision"
      >
        <Col md={6} xs={12}>
          <Lottie animationData={vissionImg} loop={true} />
        </Col>
        <Col md={6} xs={12}>
          <Typography
            sx={{ mt: 4 }}
            fontWeight={600}
            variant={matches ? "h5" : "h4"}
            component="div"
          >
            The <span className="text-danger">Vision </span>of{" "}
            <span className="text-primary">PRTP</span>
          </Typography>

          <List>
            {visions.map((vision, idx) => (
              <ListItem key={idx} data-aos="fade-up">
                <CheckCircleIcon color="primary" sx={{ fontSize: "26px" }} />
                <ListItemText
                  id="mision"
                  className="mx-2"
                  primary={vision.vis}
                  secondary={secondary ? "Secondary text" : null}
                />
              </ListItem>
            ))}
          </List>
        </Col>
      </Row>
    </Container>
  );
};

export default PRTPVision;

const visions = [
  {
    vis: "To prepare participants to become independent, successful researchers who can make meaningful contributions to their filed of study.",
  },
  {
    vis: "The vision of a Professional Research Training Program is to provide individuals with the knowledge, skills, and experience needed to conduct high-quality research in their field of study.",
  },
  {
    vis: "To be inclusive and diverse, catering to the nedds of different backgrounds and cultures, and promoting the participation of underrepresented groups in research",
  },
];
